import React from 'react';

const tmea = () => {
    return (
        <div>
            <svg 
className='logo logo1'
 width="300.000000pt" height="300.000000pt" viewBox="0 0 300.000000 300.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)"
 stroke="none">
<path d="M80 2580 l0 -340 700 0 700 0 0 340 0 340 -700 0 -700 0 0 -340z"/>
<path d="M1737 2905 c-56 -21 -121 -71 -156 -121 -62 -86 -61 -72 -61 -695 l0
-569 341 0 340 0 -3 568 c-3 566 -3 567 -26 625 -29 70 -98 144 -167 177 -62
30 -207 38 -268 15z"/>
<path d="M2453 2902 c-90 -32 -150 -90 -195 -188 -23 -49 -23 -50 -26 -621
l-3 -573 341 0 340 0 0 573 0 572 -26 55 c-31 68 -93 134 -159 168 -67 35
-195 41 -272 14z"/>
<path d="M440 1860 l0 -340 340 0 340 0 0 340 0 340 -340 0 -340 0 0 -340z"/>
<path d="M349 1480 c-97 -16 -185 -84 -236 -182 -25 -48 -28 -63 -28 -153 1
-88 4 -106 27 -150 35 -66 100 -128 168 -159 l55 -26 573 0 572 0 0 340 0 340
-542 -1 c-299 -1 -564 -5 -589 -9z"/>
<path d="M2088 1479 c-208 -27 -408 -175 -503 -374 -24 -49 -48 -114 -54 -143
-7 -33 -11 -208 -11 -462 l0 -410 340 0 340 0 0 700 0 700 -22 -1 c-13 -1 -53
-5 -90 -10z"/>
<path d="M2230 791 l0 -701 341 0 340 0 -4 438 c-4 484 -1 466 -74 605 -26 49
-64 98 -120 154 -67 68 -98 90 -175 127 -89 43 -141 57 -255 71 l-53 7 0 -701z"/>
<path d="M334 759 c-105 -24 -209 -123 -241 -229 -23 -80 -14 -193 23 -260 37
-68 111 -134 180 -159 53 -20 74 -21 619 -21 l565 0 0 340 0 340 -552 -1
c-304 -1 -571 -5 -594 -10z"/>
</g>
</svg>
        </div>
    );
};

export default tmea;


// WEBPACK FOOTER //
// ./src/Components/Footer/tmea.js